import React from 'react';
import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { setUser } from '../../redux/reducers/user';

export const LoginView = () => {
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');

	const dispatch = useDispatch();

	const handleSubmit = (event) => {
		event.preventDefault();

		// Fetch userName and Password for Login
		fetch(`https://theflix-api.herokuapp.com/login?userName=${username}&password=${password}`, {
			method: 'POST',
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.token) {
					localStorage.setItem('user', JSON.stringify(data.user));
					localStorage.setItem('token', data.token);

					dispatch(setUser(data.user));

					console.log('Logged In as : ', data.user.userName);
				}
			})
			.catch((e) => {
				alert('something went wrong in Login');
			});
	};
	return (
		<>
			<Form onSubmit={handleSubmit}>
				<Form.Group controlId='formUsername'>
					<Form.Label>UserName:</Form.Label>
					<Form.Control
						type='text'
						value={username}
						minLength={5}
						onChange={(e) => setUsername(e.target.value)}
						required
					/>
				</Form.Group>
				<Form.Group controlId='formPassword'>
					<Form.Label>Password:</Form.Label>
					<Form.Control
						type='password'
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						required
					/>
				</Form.Group>

				<Button
					style={{ marginTop: '15px' }}
					variant='primary'
					type='submit'>
					Submit
				</Button>
			</Form>
		</>
	);
};
